<template>
  <page-wrapper
    :title="'ใบแจ้งหนี้'"
    ref="pageEl"
    :isInvoiceListPage="true"
    @showMobileNavBar="showMobileNavBar"
  >
    <div class="partner">
      <!-- Admin -->
      <el-tabs v-model="activeStatus" class="mt-4" v-if="isRuejaiPartnerAdmin">
        <el-tab-pane key="in_progress" name="in_progress" label="ระหว่างตรวจสอบ">
          <invoice-list
            status="in_progress"
            :activeStatus="activeStatus" />
        </el-tab-pane>
        <el-tab-pane key="rejected" name="rejected" label="ไม่อนุมัติ">
          <invoice-list
            status="rejected"
            :activeStatus="activeStatus" />
        </el-tab-pane>
        <el-tab-pane key="transferred" name="transferred" label="เสร็จสิ้น">
          <invoice-list
            status="transferred"
            :activeStatus="activeStatus" />
        </el-tab-pane>
      </el-tabs>

      <!-- Partner -->
      <el-tabs v-model="activeStatus" class="mt-4" v-else>
        <el-tab-pane key="un_billed" name="un_billed" label="หน้าหลัก">
          <dashboard-body
            @onItemClick="handleDashboardItemClick"
            status="un_billed"
            :activeStatus="activeStatus" />
        </el-tab-pane>
        <el-tab-pane key="in_progress" name="in_progress" label="ระหว่างตรวจสอบ">
          <invoice-list
            status="in_progress"
            :activeStatus="activeStatus" />
        </el-tab-pane>
        <el-tab-pane key="rejected" name="rejected" label="ไม่อนุมัติ">
          <invoice-list
            status="rejected"
            :activeStatus="activeStatus" />
        </el-tab-pane>
        <el-tab-pane key="transferred" name="transferred" label="เสร็จสิ้น">
          <invoice-list
            status="transferred"
            :activeStatus="activeStatus" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../components/SupplierPageWrapper";
import DashboardBody from "../components/InvoiceDashboardBody";
import InvoiceList from "../components/InvoiceDashboardInvoiceList";
import { permissionRole } from "../../lib/mapper";

export default {
  components: {
    PageWrapper,
    DashboardBody,
    InvoiceList,
  },
  data() {
    return {
      roleId: parseInt(localStorage.getItem("supplierRoleId")),
      activeStatus: 'un_billed'
    };
  },
  created() {
    this.setDefaultActiveStatus();
  },
  methods: {
    setDefaultActiveStatus() {
      const query = this.$route.query;
      const status = query.status || 'un_billed';
      
      this.activeStatus = status;
    },
    handleDashboardItemClick(status) {
      this.activeStatus = status;
    },
    showMobileNavBar() {
      this.$emit("showMobileNavBar");
    }
  },
  computed: {
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN;
    }
  },
  watch: {
    "$route.query"() {
      this.activeStatus = this.$route.query.status || 'un_billed';
    },
    activeStatus(status) {
      const { name, query: history } = this.$route;
      let query;

      if (history.status === status) {
        query = { ...history };
      } else {
        query = { status };
      }

      this.$router.replace({
        name: name,
        query
      }).catch(() => {});
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/other-web/supplier/pages/InvoiceDashboard.vue